import { CalendarGridHead_default } from "../Calendar/CalendarGridHead.js";
import { createBlock, defineComponent, guardReactiveProps, normalizeProps, openBlock, renderSlot, unref, withCtx } from "vue";

//#region src/DatePicker/DatePickerGridHead.vue?vue&type=script&setup=true&lang.ts
var DatePickerGridHead_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
	__name: "DatePickerGridHead",
	props: {
		asChild: {
			type: Boolean,
			required: false
		},
		as: {
			type: null,
			required: false
		}
	},
	setup(__props) {
		const props = __props;
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(CalendarGridHead_default), normalizeProps(guardReactiveProps(props)), {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}, 16);
		};
	}
});

//#endregion
//#region src/DatePicker/DatePickerGridHead.vue
var DatePickerGridHead_default = DatePickerGridHead_vue_vue_type_script_setup_true_lang_default;

//#endregion
export { DatePickerGridHead_default };
//# sourceMappingURL=DatePickerGridHead.js.map